import { render, staticRenderFns } from "./WasteSelectToDrop.vue?vue&type=template&id=7b58a70c&"
import script from "./WasteSelectToDrop.vue?vue&type=script&lang=js&"
export * from "./WasteSelectToDrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports